(() => {
  const STORAGE = {
    awaiting: 'grayishWelcomeAwaitingConfirmation',
    email: 'grayishWelcomeEmail'
  };

  const show = (element) => {
    if (element) element.hidden = false;
  };

  const hide = (element) => {
    if (element) element.hidden = true;
  };

  const getPostedSuccessFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('customer_posted') === 'true';
  };

  const prepareActivation = (root) => {
    root.querySelectorAll('[data-grayish-activate]').forEach((link) => {
      const delay = Number.parseInt(link.dataset.grayishDelay || '0', 10);
      const label = link.querySelector('[data-grayish-button-label]');
      const status = link.parentElement?.querySelector('[data-grayish-preparing-status]');

      const enable = () => {
        link.setAttribute('aria-disabled', 'false');
        link.classList.remove('grayish-club-offer__button--disabled');
        if (label) label.textContent = 'הפעילי 7% והמשיכי לתשלום';
        if (status) status.textContent = 'ההטבה מוכנה. בצ׳קאאוט השתמשי באותה כתובת אימייל שנרשמת איתה.';
      };

      if (delay > 0 && link.getAttribute('aria-disabled') === 'true') {
        window.setTimeout(enable, delay);
      } else {
        enable();
      }

      link.addEventListener('click', (event) => {
        if (link.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }

        sessionStorage.removeItem(STORAGE.awaiting);
      });
    });
  };

  const initialise = () => {
    const root = document.querySelector('[data-grayish-club-root]');
    if (!root || root.dataset.grayishInitialised === 'true') return;
    root.dataset.grayishInitialised = 'true';

    const forms = root.querySelectorAll('form');
    forms.forEach((form) => {
      form.addEventListener('submit', () => {
        const emailInput = form.querySelector('[data-grayish-email-input]');
        const submitButton = form.querySelector('[data-grayish-submit]');
        const email = emailInput?.value?.trim();

        if (email) sessionStorage.setItem(STORAGE.email, email);
        sessionStorage.setItem(STORAGE.awaiting, '1');

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'שומרות את ההצטרפות...';
        }
      });
    });

    const guestFormPanel = root.querySelector('[data-grayish-guest-form]');
    const guestSuccessPanel = root.querySelector('[data-grayish-guest-success]');
    const consentFormPanel = root.querySelector('[data-grayish-consent-form]');
    const consentSuccessPanel = root.querySelector('[data-grayish-consent-success]');
    const storedEmail = sessionStorage.getItem(STORAGE.email);
    const awaiting = sessionStorage.getItem(STORAGE.awaiting) === '1';
    const urlConfirmsPosting = getPostedSuccessFromUrl();

    const guestServerSuccess = guestSuccessPanel?.dataset.serverSuccess === 'true';
    const consentServerSuccess = consentSuccessPanel?.dataset.serverSuccess === 'true';

    if (guestServerSuccess || (awaiting && urlConfirmsPosting && root.dataset.customerState === 'guest')) {
      hide(guestFormPanel);
      show(guestSuccessPanel);
    }

    if (consentServerSuccess || (awaiting && urlConfirmsPosting && root.dataset.customerState === 'logged-in')) {
      hide(consentFormPanel);
      show(consentSuccessPanel);
    }

    const registeredEmail = root.querySelector('[data-grayish-registered-email]');
    if (registeredEmail && storedEmail) {
      registeredEmail.textContent = `האימייל שנרשם: ${storedEmail}`;
      show(registeredEmail);
    }

    prepareActivation(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
})();
